import { render } from "./ViewMediaFileMoreAudio.vue?vue&type=template&id=84a734ac&scoped=true"
import script from "./ViewMediaFileMoreAudio.vue?vue&type=script&lang=js"
export * from "./ViewMediaFileMoreAudio.vue?vue&type=script&lang=js"

import "./ViewMediaFileMoreAudio.vue?vue&type=style&index=0&id=84a734ac&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-84a734ac"

export default script